import {Component, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {UserService} from '@services/user.service';
import {AuthenticationService} from '@services/authentification.service';

@Component({
    selector: 'app-calendly',
    templateUrl: './calendly.component.html',
    styleUrls: ['./calendly.component.scss']
})
export class CalendlyComponent {

    link = ""

    constructor(
        public dialogRef: MatDialogRef<CalendlyComponent>,
        public userService: UserService,
        public authenticationService: AuthenticationService,
    ) {
        // if (Math.floor(Math.random() * 1) == 0) {
            this.link = "https://calendly.com/thomas-lybox/30-min"
        // } else {
        //     this.link = "https://calendly.com/mathieu-lybox/30-min"
        // }
    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }

    onYesClick(): void {
        this.dialogRef.close(true);
    }
}
